import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const slides = [
  "/images/sl3.jpg",
  "/images/sl1.jpg",
  "/images/sl2.jpg",
];

const HeroSlider: React.FC = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const next = () => {
    setCurrent((prev) => (prev + 1) % slides.length);
  };

  const prev = () => {
    setCurrent((prev) =>
      prev === 0 ? slides.length - 1 : prev - 1
    );
  };

  return (
    <section className="w-full bg-black">
      
      {/* Aspect ratio same as 1250x600 */}
      <div className="relative w-full aspect-[1250/600] overflow-hidden">

        {slides.map((image, index) => (
          <img
            key={index}
            src={image}
            alt=""
            className={`absolute inset-0 w-full h-full object-contain transition-opacity duration-700
            ${index === current ? "opacity-100" : "opacity-0"}`}
          />
        ))}

        {/* Left Button */}
        <button
          onClick={prev}
          className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/80 rounded-full p-2 shadow"
        >
          <ChevronLeft />
        </button>

        {/* Right Button */}
        <button
          onClick={next}
          className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/80 rounded-full p-2 shadow"
        >
          <ChevronRight />
        </button>

      </div>
    </section>
  );
};

export default HeroSlider;